module.exports = __webpack_public_path__ + "img/2295.169c50b2.gif";